export default __webpack_public_path__ + "static/media/img-0139-germany-half-face.5b7f1368.png";